//@ts-check
import { makeVar } from '@apollo/client';

/**
 * @typedef {import('../../EmployeesFinder/EmployeesFinder.types').Employee} Employee
 * @typedef {import('../../../containers/RHPod/Employees/EmployeeInfo/EmployeeInfo.types').EmployeeInfo} EmployeeInfo
 *
 * @typedef {object} SingleDocumentConfigurationUploadDialogVar
 * @property {boolean} open
 * @property {boolean} openConfirmDialog
 * @property {string | null} employeeId
 * @property {string | null} category
 * @property {string | null} subcategory
 * @property {EmployeeInfo & {id: string} | null} employeeData
 * @property {Employee[]} assignedCompanySigners
 * @property {string | null} selectedAction
 * @property {() => void} onClose
 * @property {() => void} onUploadSuccess
 */

/** @type {SingleDocumentConfigurationUploadDialogVar} */
const documentCreatorDialogDefault = {
  open: false,
  openConfirmDialog: false,
  employeeId: null,
  employeeData: null,
  category: null,
  subcategory: null,
  assignedCompanySigners: [],
  selectedAction: null,
  onClose: () => {
    resetDocumentCreatorDialog();
  },
  onUploadSuccess: async () => {
    console.log('onUploadSuccess CALLED');
  },
};

export const documentCreatorDialogVar = makeVar(documentCreatorDialogDefault);

export const resetDocumentCreatorDialog = () => {
  documentCreatorDialogVar(documentCreatorDialogDefault);
};

/**
 * Sets a property of the documentCreatorDialogVar.
 *
 * @param {Partial<SingleDocumentConfigurationUploadDialogVar>} input - The properties to be set on the documentCreatorDialogVar.
 */
export const setDocumentCreatorDialogVar = (input) => {
  documentCreatorDialogVar({
    ...documentCreatorDialogVar(),
    ...input,
  });
};
